import { Analytics } from './analytics';

const percentageSteps = [10, 25, 50, 75, 90]

$(".agm-video-item-video, .video-container video").on("timeupdate", (e: Event) => {
    const video = e.currentTarget as HTMLVideoElement;

    const rounding = Math.round(video.currentTime * 100 / video.duration);

    percentageSteps.forEach(step => {
        if (step === rounding && video.dataset["progression"] !== step.toString()) {
            video.dataset["progression"] = step.toString();
            Analytics.sendRawEvent({
                "event": "video",
                "interaction": {
                    "video_progress": rounding,
                    "video_title": video.dataset["title"],
                    "video_url": video.currentSrc,
                    "video_provider": "none",
                    "video_duration": video.duration
                }
            });
        }
    });
});